import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getCities = async () => {
  const { data, error } = await supabase.from('cities').select('*').order('name');

  if (error) {
    throw error;
  }

  return data;
};

export const createCity = async cityData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('cities').insert([cityData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateCity = async (id, cityData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('cities')
    .upsert({ ...cityData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteCity = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('cities').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
